import { ThaliaLogo } from "@assets/ThaliaLogo";

export const ThaliaHeader = () => {
	return (
		<header className="sticky top-0 z-50 w-full border-b bg-white shadow-sm">
			<div className="container mx-auto flex h-14 items-center justify-center px-3 sm:px-4">
				<ThaliaLogo />
			</div>
		</header>
	);
};
